import * as React from 'react';
import { Link } from 'react-router-dom';
import { STATE } from 'app/constants';
import { withSimpleForm } from 'app/infrastructure/simple-form/with-simple-form';
import { actionCreators } from './actions';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';
import { SerializeType, SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { simpleFieldForPath } from 'app/infrastructure/simple-form/';
import { ExportsModalState } from 'app/area/my-downloads/exports/export-to-zip-modal/types-store';
import { routeConstants } from 'app/routes/route-constants';
import { exportToZipTranslations } from 'app/area/my-downloads/exports/export-to-zip-modal/constants';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
export interface ExportToZipModalProps extends ExportsModalState {
  onClose: () => void;
}

const SimpleForm = simpleFieldForPath(STATE.myDownloads);

export type ExportsContainerProps = ExportToZipModalProps & typeof actionCreators & DefaultContainerProps & SimpleFormProps;

export class ExportToZipModalComponent extends React.Component<ExportsContainerProps, any> {

  public static statePath: string = STATE.myDownloads;

  private onSubmit = () => {
    const { params, serialize, translation } = this.props;
    this.props.exportCases(
      params.favouriteId,
      serialize(defaultSerializeMappings),
      () => <Link
        style={{ color: '#fff' }}
        to={routeConstants.myDownloadsView}>
        {translation.export_success}
      </Link>);
    this.props.onClose();
  };

  public render() {
    const { onClose, translation, exportsModal } = this.props;
    return <ModalWrapper
              headerTitle={translation.export_modal_title}
              btnTitle={translation.export_modal_submit}
              btnCancelTitle={translation.export_modal_cancel}
              isDisabled={exportsModal.fetching}
              onDone={this.onSubmit}
              onClose={onClose}
              largeSize={false}
              closeOnDone={false}>
                <p>{translation.export_modal_description_1}</p>
                <p>{translation.export_modal_description_2}</p>
                <SimpleForm
                  name="comments"
                  type={FIELD_TYPE.TEXTAREA}
                  label={{ text: translation.export_modal_comment }}
                  initialValue={''}
                  maxLength={254}
                  serialize={{ type: SerializeType.PRIMITIVE_VALUE }} />
          </ModalWrapper>;

  }
}

const container = containerFactory<ExportToZipModalComponent>(withSimpleForm(ExportToZipModalComponent),
  actionCreators, undefined, exportToZipTranslations);

export { container as ExportToZipModal };
